export class UserPosition {
  public providerPositionID: number;
  public positionCode: string;
  public positionDisplayName: string;
  public positionDesc: string;
  public positionOrdinal: number;
  public isActive: boolean;
}
